<template>
  <el-row :gutter="20">
    <el-col :span="24">
      <div class="form-group">
        <el-form-item>
          <label
            class="field-title-label text-black-600 !text-xs 2xl:!text-sm font-normal block !mb-0.5"
          >
            Value
            <span class="text-red-500">*</span>
          </label>
          <el-input-number
            v-model="field.value"
            v-if="field.input_type == 'NUMBER'"
            :controls="false"
            class="!w-full"
          ></el-input-number>
          <el-input
            v-else-if="field.input_type == 'SINGLE_LINE_TEXT'"
            v-model="field.value"
            type="text"
            maxlength="64"
            class="!w-full"
          ></el-input>
          <el-input
            v-else-if="field.input_type != 'NUMBER' && field.input_type != 'SINGLE_LINE_TEXT'"
            v-model="field.value"
            type="text"
            class="!w-full"
          ></el-input>
          <el-input v-else v-model="field.value" type="number"></el-input>
          <FormError error-key="value" />
        </el-form-item>
      </div>
    </el-col>
  </el-row>
</template>

<script>
  import FormError from '@/components/form/FormError';
  export default {
    components: { FormError },
    props: ['field'],
    data() {
      return {};
    },
    mountd() {},
  };
</script>

<style lang="scss">
  // @media (max-width: 767px) {
  //   .value-col {
  //     width: 100%;
  //     padding: 0 15px;
  //   }
  // }
</style>
